import React from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

export type LineProps = {
  header?: boolean
  width: string
}

export const Line = ({ header, ...rest }: LineProps) => (
  <Styled.PlaceholderLineWrapper
    className={reactClass(`loading-placeholder${header ? '-header' : '-line'}`)}
    {...rest}
  />
)
